import React, { useState, useMemo } from 'react';
import { useAuth } from "../../src/Context/AuthContext"

const IssuePacketSection = ({ model, rowsPerPage = 10 }) => {
    //State Variables
    const docs = model.issuePackets || [];
    const filtered = docs.filter(doc => doc);
    const [currentPage, setCurrentPage] = useState(1);
    const totalEntries = filtered.length;
    const totalPages = Math.ceil(totalEntries / rowsPerPage);
    const [pdfBlob, setPdfBlob] = useState(null);
    const [showModal, setShowModal] = useState(false);
    const { logout } = useAuth();

    //ENV Variables
    const apiURL = import.meta.env.VITE_API;

    const paginatedDocs = useMemo(() => {
        const start = (currentPage - 1) * rowsPerPage;
        return filtered.slice(start, start + rowsPerPage);
    }, [filtered, currentPage, rowsPerPage]);

    const handlePageChange = (page) => {
        if (page >= 1 && page <= totalPages) {
            setCurrentPage(page);
        }
    };

    const getPDF = async (id) => {
        try {
            const res = await fetch(`${apiURL}/image/pdf/download?documentID=${id}`, {
                method: "GET",
                headers: {
                    Authorization: `Bearer ${localStorage.getItem("token")}`
                }
            });

            if (res.status === 401) {
                logout();
                navigate('/login');
                throw new Error("unauthorized");
            }

            if (res.status === 403) {
                navigate('/home');
                throw new Error("forbidden");
            }

            if (!res.ok) {
                throw new Error("Failed to fetch PDF");
            }

            return await res.blob();
        } catch (err) {
            console.error(err);
            alert("Could not retrieve file");
            return null;
        }
    };

    const handleView = async (id) => {
        const blob = await getPDF(id);
        if (!blob) return;

        setPdfBlob(blob);
        setShowModal(true);
    };

    const closeModal = () => {
        setShowModal(false);
        setPdfBlob(null);
    };

    const from = totalEntries === 0 ? 0 : (currentPage - 1) * rowsPerPage + 1;
    const to = Math.min(currentPage * rowsPerPage, totalEntries);

    return (
        <div className="container container-section" id="documents-container">
            {filtered.length === 0 ? (
                <div className="card notfoundbox rounded-3 shadow-lg">
                    <div className="card-body">
                        <h5>No Documents Found</h5>
                    </div>
                </div>
            ) : (
                <>
                    <table className="policy-results-table">
                        <thead>
                            <tr>
                                <th>Document Name</th>
                                <th>View</th>
                            </tr>
                        </thead>
                        <tbody>
                            {paginatedDocs.map((doc, index) => (
                                <tr key={index}>
                                    <td>{doc.displayName}</td>
                                    <td>
                                        {doc.fileName?.toLowerCase().endsWith('.pdf') && (
                                            <button className="baseButton" onClick={() => handleView(doc.id)}>View</button>
                                        )}
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>

                    <div className="pagination-bar">
                        <div className="pagination-summary">
                            Showing {from}-{to} of {totalEntries} entries
                        </div>
                        <div className="pagination-controls">
                            <button onClick={() => handlePageChange(1)} disabled={currentPage === 1}>&#171;</button>
                            <button onClick={() => handlePageChange(currentPage - 1)} disabled={currentPage === 1}>&#8592;</button>

                            {[...Array(totalPages)].map((_, i) => {
                                const page = i + 1;
                                return (
                                    <button
                                        key={page}
                                        onClick={() => handlePageChange(page)}
                                        className={currentPage === page ? 'active' : ''}
                                    >
                                        {page}
                                    </button>
                                );
                            })}

                            <button onClick={() => handlePageChange(currentPage + 1)} disabled={currentPage === totalPages}>&#8594;</button>
                            <button onClick={() => handlePageChange(totalPages)} disabled={currentPage === totalPages}>&#187;</button>
                        </div>
                    </div>

                    {/* PDF Modal */}
                    {showModal && pdfBlob && (
                        <div className="pdf-modal-overlay">
                            <button className="pdf-modal-close" onClick={closeModal}>x Close</button>
                            <div className="pdf-modal-content">

                                <iframe
                                    src={URL.createObjectURL(pdfBlob)}
                                    title="PDF Viewer"
                                    className="pdf-iframe"
                                />
                            </div>
                        </div>
                    )}
                </>
            )}
        </div>
    );
};

export default IssuePacketSection;
